"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.updatePickupVoucherPrintInfo = updatePickupVoucherPrintInfo;
exports.isPickupVouchersLoaded = isPickupVouchersLoaded;
exports.loadPickupVouchers = loadPickupVouchers;
exports.loadPickupVouchersByToken = loadPickupVouchersByToken;

var _VoucherUtil = require("../../utils/VoucherUtil");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_USER_VOUCHERS = "maaporssi/pickupVouchers/LOAD_USER_VOUCHERS";
var LOAD_USER_VOUCHERS_SUCCESS = "maaporssi/pickupVouchers/LOAD_USER_VOUCHERS_SUCCESS";
var LOAD_USER_VOUCHERS_FAIL = "maaporssi/pickupVouchers/LOAD_USER_VOUCHERS_FAIL";

var SAVE_VOUCHERS_PRINT_INFO = "maaporssi/pickupVouchers/SAVE_VOUCHERS_PRINT_INFO";
var SAVE_VOUCHERS_PRINT_INFO_SUCCESS = "maaporssi/pickupVouchers/SAVE_VOUCHERS_PRINT_INFO_SUCCESS";
var SAVE_VOUCHERS_PRINT_INFO_FAIL = "maaporssi/pickupVouchers/SAVE_VOUCHERS_PRINT_INFO_FAIL";

var initialState = {
  orderType: _VoucherUtil.PICKUP_ORDER_TYPE,
  vouchersLoaded: false,
  vouchers: [],
  vouchersInfoUpdated: false
};

function mapOrders(order) {
  return order.items.map(function (item) {
    item.order_id = order.id;
    item.order_first_name = order.first_name;
    item.order_last_name = order.last_name;
    if (order.company_name) {
      item.order_company_name = order.company_name;
    }
    return item;
  });
}

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_USER_VOUCHERS:
      return (0, _extends3.default)({}, state, {
        vouchersLoading: true
      });
    case LOAD_USER_VOUCHERS_FAIL:
      return (0, _extends3.default)({}, state, {
        vouchersLoading: false,
        vouchersLoaded: true,
        vouchersError: action.error.error
      });
    case LOAD_USER_VOUCHERS_SUCCESS:
      var result = Array.isArray(action.result) ? action.result : [action.result];
      var itemsArray = result.map(mapOrders);
      var vouchers = [].concat.apply([], itemsArray);
      return (0, _extends3.default)({}, state, {
        vouchersLoading: false,
        vouchersLoaded: true,
        vouchers: vouchers
      });
    case SAVE_VOUCHERS_PRINT_INFO:
      return (0, _extends3.default)({}, state, {
        voucherInfoUpdating: true
      });
    case SAVE_VOUCHERS_PRINT_INFO_FAIL:
      return (0, _extends3.default)({}, state, {
        voucherInfoUpdating: false,
        vouchersInfoUpdated: true,
        vouchersInfoError: action.error.error
      });
    case SAVE_VOUCHERS_PRINT_INFO_SUCCESS:
      return (0, _extends3.default)({}, state, {
        voucherInfoUpdating: false,
        vouchersInfoUpdated: true,
        vouchers: vouchers
      });
    default:
      return state;
  }
}
function updatePickupVoucherPrintInfo(data) {

  return {
    types: [SAVE_VOUCHERS_PRINT_INFO, SAVE_VOUCHERS_PRINT_INFO_SUCCESS, SAVE_VOUCHERS_PRINT_INFO_FAIL],
    promise: function promise(client) {
      return client.post("/soil_pickup_voucher_print_info/", {
        data: data
      });
    }
  };
}

function isPickupVouchersLoaded(globalState) {
  return globalState.userPickupVouchers && globalState.userPickupVouchers.vouchersLoaded;
}

function loadPickupVouchers() {
  return {
    types: [LOAD_USER_VOUCHERS, LOAD_USER_VOUCHERS_SUCCESS, LOAD_USER_VOUCHERS_FAIL],
    promise: function promise(client) {
      return client.get("/soil_pickup_orders");
    }
  };
}

function loadPickupVouchersByToken(token) {
  return {
    types: [LOAD_USER_VOUCHERS, LOAD_USER_VOUCHERS_SUCCESS, LOAD_USER_VOUCHERS_FAIL],
    promise: function promise(client) {
      return client.get("/soil_pickup_orders/" + token);
    }
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/userPickupVouchers.js
 ** module id = 208
 ** module chunks = 0
 **/